import React from 'react';
import * as metaPixel from 'meta-pixel';
import { Users, TrendingUp, Clock, Heart, Moon, Utensils } from 'lucide-react';
const handleLearnMoreClick = () => {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      metaPixel.track('CustomEvent', {
        event: 'LearnMoreClick',
        section: 'Benefits and Results'
      });
    }
  } catch (error) {
    console.error('Error tracking learn more click:', error);
  }
};
export function BenefitsAndResults() {
  return <section className="py-10 bg-amber-50" id="beneficios-resultados" data-id="element-17">
      <div className="container mx-auto px-4 md:px-6" data-id="element-18">
        <div className="max-w-3xl mx-auto" data-id="element-19">
          <div className="mb-8" data-id="element-20">
            <h2 className="text-2xl md:text-3xl font-bold text-amber-900 mb-4 font-serif text-center" data-id="element-21">
              Solución y beneficios
            </h2>
            <p className="text-amber-800 text-center" data-id="element-22">
              Un sistema visual imprimible + guiones firmes-y-amables para
              transformar las rutinas diarias
            </p>
          </div>
          {/* Para quién es */}
          <div className="mb-10" data-id="element-23">
            <div className="flex items-center gap-3 mb-4 justify-center" data-id="element-24">
              <Users size={24} className="text-amber-700" data-id="element-25" />
              <h3 className="text-xl font-bold text-amber-900" data-id="element-26">
                Ideal para familias que:
              </h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-27">
              <div className="bg-white p-4 rounded-lg border border-amber-100" data-id="element-28">
                <p className="text-amber-900 text-sm" data-id="element-29">
                  Tienen niños de 0–7 años con mañanas o noches caóticas
                </p>
              </div>
              <div className="bg-white p-4 rounded-lg border border-amber-100" data-id="element-30">
                <p className="text-amber-900 text-sm" data-id="element-31">
                  Buscan disciplina positiva: límites claros + conexión
                </p>
              </div>
              <div className="bg-white p-4 rounded-lg border border-amber-100" data-id="element-32">
                <p className="text-amber-900 text-sm" data-id="element-33">
                  Necesitan soluciones prácticas sin teorías interminables
                </p>
              </div>
            </div>
          </div>
          {/* Resultados esperados */}
          <div data-id="element-34">
            <h3 className="text-xl font-bold text-amber-900 mb-4 text-center" data-id="element-35">
              Resultados que puedes esperar
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-36">
              <div className="bg-white p-3 rounded-lg border border-amber-100 flex gap-3" data-id="element-37">
                <Clock size={20} className="text-amber-700 flex-shrink-0" data-id="element-38" />
                <p className="text-amber-900 text-sm" data-id="element-39">
                  20–30% menos tiempo en rutinas matutinas
                </p>
              </div>
              <div className="bg-white p-3 rounded-lg border border-amber-100 flex gap-3" data-id="element-40">
                <TrendingUp size={20} className="text-amber-700 flex-shrink-0" data-id="element-41" />
                <p className="text-amber-900 text-sm" data-id="element-42">
                  Berrinches más cortos y menos intensos
                </p>
              </div>
              <div className="bg-white p-3 rounded-lg border border-amber-100 flex gap-3" data-id="element-43">
                <Heart size={20} className="text-amber-700 flex-shrink-0" data-id="element-44" />
                <p className="text-amber-900 text-sm" data-id="element-45">
                  Más cooperación y autonomía infantil
                </p>
              </div>
              <div className="bg-white p-3 rounded-lg border border-amber-100 flex gap-3" data-id="element-46">
                <Moon size={20} className="text-amber-700 flex-shrink-0" data-id="element-47" />
                <p className="text-amber-900 text-sm" data-id="element-48">
                  Noches tranquilas y transiciones previsibles
                </p>
              </div>
            </div>
            <div className="mt-8 flex justify-center" data-id="element-49">
              <a href="https://pay.hotmart.com/E103092077E" onClick={handleLearnMoreClick} data-id="element-50">
                <button className="bg-amber-700 hover:bg-amber-800 text-white font-medium py-2 px-5 rounded-md" data-id="element-51">
                  Quiero estos resultados →
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}